import { apiExplorerConstants } from '../_constants';

export function listAPIs(state = {}, action) {
    switch (action.type) {
      case apiExplorerConstants.GETALL_APIS_REQUEST:
        return {
          loading: true
        };
      case apiExplorerConstants.GETALL_APIS_SUCCESS:
        return {
          items: action.apis
        };
      case apiExplorerConstants.GETALL_APIS_FAILURE:
        return { 
          error: action.error
        };
      default:
        return state
    }
  }

  export function apiDetails(state = {}, action) {
    switch (action.type) {
      case apiExplorerConstants.GET_API_DETAILS_REQUEST:
        return {
          loading: true
        };
      case apiExplorerConstants.GET_API_DETAILS_SUCCESS:
        return {
          items: action.api
        };
      case apiExplorerConstants.GET_API_DETAILS_FAILURE:
        return { 
          error: action.error
        };
      default:
        return state
    }
  }

  
  export function apiTopCards(state = {}, action) {
    switch (action.type) {
      case apiExplorerConstants.GET_API_TOP_CARD_INFO_REQUEST:
        return {
          loading: true
        };
      case apiExplorerConstants.GET_API_TOP_CARD_INFO_SUCCESS:
        return {
          items: action.apiTopCards
        };
      case apiExplorerConstants.GET_API_TOP_CARD_INFO_FAILURE:
        return { 
          error: action.error
        };
      default:
        return state
    }
  }

  export function testResult(state = {}, action) {
    switch (action.type) {
      case apiExplorerConstants.GET_API_RESULT_REQUEST:
        return {
          loading: true
        };
      case apiExplorerConstants.GET_API_RESULT_SUCCESS:
        return {
          items: action.result
        };
      case apiExplorerConstants.GET_API_RESULT_FAILURE:
        return { 
          error: action.error
        };
      default:
        return state
    }
  }

  export function filtersAPI(state={}, action){
    switch (action.type) {
      case apiExplorerConstants.GET_API_FILTER_REQUEST:
        return {
          loading: true
        };
      case apiExplorerConstants.GET_API_FILTER_SUCCESS:
        return {
          items: action.filtersAPI
        };
      case apiExplorerConstants.GET_API_FILTER_FAILURE:
        return { 
          error: action.error
        };
      default:
        return state
    }

  }

  export function approveAPI(state = {}, action) {
    switch (action.type) {
      case apiExplorerConstants.APIEXPLORER_STATUS_UPDATE_REQUEST:
        return {
          loading: true
        };
      case apiExplorerConstants.APIEXPLORER_STATUS_UPDATE_SUCCESS:
        return {
          items: action.data
        };
      case apiExplorerConstants.APIEXPLORER_STATUS_UPDATE_FAILURE:
        return { 
          error: action.error
        };
      default:
        return state
    }
  }